/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Mentions_EmptyInputs */

const en_notes_mentions_empty = /** @type {(inputs: Notes_Mentions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No people found.`)
};

const pt_br2_notes_mentions_empty = /** @type {(inputs: Notes_Mentions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma pessoa encontrada.`)
};

/**
* | output |
* | --- |
* | "No people found." |
*
* @param {Notes_Mentions_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notes_mentions_empty = /** @type {((inputs?: Notes_Mentions_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Mentions_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notes_mentions_empty(inputs)
	return pt_br2_notes_mentions_empty(inputs)
});